import { Flex, Image, Text } from "@chakra-ui/react";
import rexRealEstateLogoDark from "assets/rex-real-estate-logo-dark.png";
import type { SessionData } from "contexts/session";

export function DisplayBannerImage({ user }: { user?: SessionData }) {
  return (
    <Flex align={"center"} gap={"2"}>
      <Image
        src={user?.silo?.logo ?? rexRealEstateLogoDark}
        fallbackSrc={rexRealEstateLogoDark}
        alt={user?.silo?.display_name ?? "Rex Real Estate"}
        h={"50px"}
      />
      <Text textStyle={"xl"} textTransform={"uppercase"}>
        {user?.silo?.display_name ?? "Rex Real Estate"}
      </Text>
    </Flex>
  );
}
